import { WebApiRequest, HTTP_POST } from "tools/webservice";
import { api } from "apis/cubiCasa";

export const submitFixRequest = (controlNumber, payload, successCallback, errorCallBack, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.submitFixRequest(controlNumber),
  payload,
  successCallback: successCallback,
  errorCallback: errorCallBack,
  mountedRef: mountedRef
});